export default __webpack_public_path__ + "static/char-thumb-39-6d89ac6e348e4009bf61216ddd7ec7bd.png";